(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2145],{

/***/ 22636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print",
      function () {
        return __webpack_require__(63640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32511);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32252);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44027);
/* harmony import */ var _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99076);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30719);
/* harmony import */ var _components_customizing_print_PrintDesignService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52658);
/* harmony import */ var _components_customizing_print_printTab_PrintTab__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48071);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);












var CustomizingPrintPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            parent: "\uD648",
            sub: "\uC18C\uB7C9\uC778\uC1C4",
            pageTitle: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_4__/* .SeoMeta.smallPrintService.title */ .e.smallPrintService.title,
            pageDesc: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_4__/* .SeoMeta.smallPrintService.description */ .e.smallPrintService.description,
            pageKeyword: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_4__/* .SeoMeta.smallPrintService.keywords */ .e.smallPrintService.keywords,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_printTab_PrintTab__WEBPACK_IMPORTED_MODULE_8__/* .PrintTab */ .d, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                    src: "/img/print/print_01.png",
                    alt: "\uC18C\uB7C9\uC778\uC1C4_\uC0C1\uD488\uC18C\uAC1C",
                    width: 1900,
                    height: 367,
                    style: {
                        width: "100%",
                        height: "auto",
                        minWidth: "300px"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalTitle */ .XG, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: "\uC18C\uB7C9\uC778\uC1C4, "
                                }),
                                " \uC774\uB7F0 \uBD84\uB4E4\uAED8 \uCD94\uCC9C\uB4DC\uB9BD\uB2C8\uB2E4."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthWarpper */ .nT, {
                            children: _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .strengthArr.map */ .AA.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthItem */ .iW, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .HighlightText */ .yb, {
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthImage */ .sz, {
                                            src: item.img,
                                            alt: "strength-".concat(index)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ArrowText */ .Iv, {
                                            children: item.desc.join("\n")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalText */ .X0, {
                                            children: item.memo.join("\n")
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthSliderWrapper */ .vw, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "strengthSection",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthPC */ .lz, {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                        children: [
                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "\uC18C\uB7C9\uC778\uC1C4"
                                            }),
                                            "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "strengthGrid",
                                        children: _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .strengthSlideArr.map */ .vW.map(function(str, idx) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "content",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: str.img
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "desc",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                children: str.title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: str.desc
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "container swiperSection",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                    navigation: {
                                        prevEl: ".custom_prev_i1",
                                        nextEl: ".custom_next_i1"
                                    },
                                    pagination: {
                                        clickable: true,
                                        el: ".swiper-pagination"
                                    },
                                    children: _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .strengthSlideArr.map */ .vW.map(function(str, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .StrengthSlide */ .AZ, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                                        children: [
                                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                children: "\uC18C\uB7C9\uC778\uC1C4"
                                                            }),
                                                            "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "content",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: str.img
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "desc",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                        children: str.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: str.desc
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, idx);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "slider-arrow",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "slider-btn slider-prev slick-arrow custom_prev_i1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-angle-left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "slider-btn slider-next slick-arrow custom_next_i1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-angle-right"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "swiper-pagination"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductWrapper */ .ZG, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalTitle */ .XG, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: "\uC18C\uB7C9\uC778\uC1C4 \uAC00\uB2A5 \uC0C1\uD488"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductGrid */ .eQ, {
                                children: _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .productArr.map */ .Yl.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductItem */ .Cd, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductImage */ .qN, {
                                                src: item.img,
                                                alt: item.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductDesc */ .KE, {
                                                children: item.title
                                            })
                                        ]
                                    }, "".concat(index, "_product"));
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .OutlineBtn */ .Fk, {
                                className: "btn mt-50",
                                onClick: function() {
                                    return router.push("/customizing/print/product/");
                                },
                                children: "\uC18C\uB7C9\uC778\uC1C4 \uC0C1\uD488 \uC120\uD0DD\uD558\uAE30"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProcessWrapper */ .Yd, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalTitle */ .XG, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: "\uC18C\uB7C9\uC778\uC1C4 \uC9C4\uD589 \uACFC\uC815"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProcessGrid */ .XP, {
                                children: _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .progressArr.map */ .kb.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProcessItem */ .Js, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProcessImage */ .rp, {
                                                        src: item.img,
                                                        alt: item.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProcessDesc */ .Tj, {
                                                        children: item.title
                                                    })
                                                ]
                                            }),
                                            index !== _components_customizing_print_Print_data__WEBPACK_IMPORTED_MODULE_5__/* .progressArr.length */ .kb.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .Arrow */ .Eh, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "fi-rs-angle-right"
                                                })
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .NormalTitle */ .XG, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "\uC81C\uC791 \uC0AC\uB840"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_9___default()), {
                            src: "/img/print/print_06.png",
                            alt: "\uC18C\uB7C9\uC778\uC1C4_\uC0C1\uD488\uC18C\uAC1C",
                            width: 1120,
                            height: 540,
                            style: {
                                width: "100%",
                                height: "auto"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .CaseButton */ .pj, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_2__/* .OutlineBtn */ .Fk, {
                                className: "btn",
                                onClick: function() {
                                    return router.push("/customizing/print/guide/");
                                },
                                children: "\uC81C\uC791 \uAC00\uC774\uB4DC \uBCF4\uAE30"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_PrintDesignService__WEBPACK_IMPORTED_MODULE_7__/* .PrintDesignService */ .$, {})
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CustomizingPrintPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,9007,1850,9774,2888,179], function() { return __webpack_exec__(22636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);